// removed by extract-text-webpack-plugin
module.exports = {"js_togggleControls":"ControlsToggle__js_togggleControls__1FThu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ControlsToggle/ControlsToggle.css
// module id = 141
// module chunks = 0